<template>
  <div class="body-section">
    <div>
      <div class="title-section" style="display: flex">
        <h1 class="title title-ruban">VOTRE QUESTIONNAIRE</h1>
      </div>
      <div class="page-seperate"></div>
    </div>
    <b-steps
      v-model="activeStep"
      :has-navigation="false"
      style="margin-top: 2em"
    >
      <b-step-item step="1" label="Introduction" :clickable="activeStep < 3">
        <h1 class="title has-text-centered">Avant de commencer</h1>
        <p>
          Vous êtes sur le point de commencer le questionnaire
          <strong>{{ this.survey.title }}</strong> réalisé par Management &
          Humanisme.
        </p>
        <p>
          Votre situation sera étudiée de manière isolée dans le but
          {{ survey.objectif }}. Vos réponses resteront strictement
          confidentielles en dehors de cette étude.
        </p>
        <p>
          Conformément à la loi informatique et libertés et au RGPD, vous
          disposez d'un droit d'accès, modification et suppression que vous
          pourrez exercer sur simple demande à contact@mh-conseil.com. Enfin,
          vous disposez du droit de former un recours aupres de l'autorité de
          contrôle dont vous dépendez.
        </p>
        <p>
          En démarrant ce questionnaire, vous consentez à sauvegader les
          informations saisies, pouvant être à caractère personnelle (mail, nom,
          prénom...), selon les conditions générales d'utilisation.
        </p>
      </b-step-item>

      <b-step-item
        step="2"
        label="Consignes de passation"
        :clickable="activeStep < 3"
      >
        <h1 class="title has-text-centered">Consignes de passation</h1>
        <p v-html="survey.instruction"></p>
      </b-step-item>
      <b-step-item
        step="3"
        :label="'Questionnaire ' + this.survey.smallTitle"
        :clickable="activeStep == 1"
      >
        <h1 class="title has-text-centered">
          Questionnaire {{ survey.smallTitle }}
        </h1>
        <b-progress
          type="is-success"
          :value="(activeStepSurvey / surveyQuestions.length) * 100 + 5"
          style="width: 30vw; margin: auto"
          show-value
        >
          {{
            surveyQuestions.length > activeStepSurvey
              ? "Partie " +
                (activeStepSurvey + 1) +
                " / " +
                surveyQuestions.length
              : "100%"
          }}
        </b-progress>
        <b-steps v-model="activeStepSurvey" :has-navigation="false">
          <b-step-item
            v-for="surveyQuestion in surveyQuestions"
            :key="surveyQuestion.page"
            :step="surveyQuestion.page"
            :label="'Partie' + surveyQuestion.page"
          >
            <h2
              v-if="surveyQuestion.instructions != undefined"
              class="subtitle"
            >
              {{ surveyQuestion.instructions }}
            </h2>
            <div style="width: 80vw; margin: auto">
              <survey-row-input
                v-for="questionRow in surveyQuestion.questions"
                :key="questionRow.order"
                :surveyRow="questionRow"
              ></survey-row-input>
            </div>
          </b-step-item>
          <b-step-item :step="surveyQuestions.length" label="Valider">
            <h1 class="title has-text-centered">Valider Vos Réponses</h1>
            <p>Valider le questionnaire et obtenir votre profil ITP.</p>
            <p>
              Cette action sera définitive, vous ne pourrez plus modifier vos
              réponses.
            </p>
          </b-step-item>

          <template v-if="activeStep == 2" #navigation="{ previous, next }">
            <div style="text-align: center">
              <b-button
                v-if="activeStepSurvey > 0"
                outlined
                type="is-primary"
                size="is-small"
                icon-pack="fas"
                icon-left="backward"
                :disabled="previous.disabled"
                @click.prevent="previous.action"
              >
                Précédent
              </b-button>
              <b-button
                outlined
                type="is-primary"
                size="is-small"
                icon-pack="fas"
                icon-right="forward"
                :loading="isNextLoading"
                :disabled="
                  surveyQuestions.length > activeStepSurvey &&
                  surveyQuestions[activeStepSurvey].questions.reduce(
                    (previousValue, currentValue) =>
                      Math.max(previousValue, currentValue.order),
                    0
                  ) > $store.state.survey.surveyAnswerCount
                "
                @click.prevent="next.action"
                @click="ValidateAnswers()"
              >
                {{
                  surveyQuestions.length > activeStepSurvey
                    ? "Suivant"
                    : "Terminer et obtenir mon profil"
                }}
              </b-button>
            </div>
          </template>
        </b-steps>
      </b-step-item>
      <b-step-item step="4" label=" Résultat" :clickable="false">
        <h1 class="title has-text-centered">Votre Résultat</h1>
        <p>
          Merci d'avoir complété votre questionnaire, vous pouvez consulter
          ci-dessous votre resultat.
        </p>
        <p>
          Un email vous a été envoyé à l'addresse utilisée en identifiant de ce
          site.
        </p>

        <result-card
          :surveyResult="GetResultat()"
          :userName="this.$store.state.user.nameSurname"
          :userPosition="this.$store.state.user.position"
          style="margin-top: 1em"
        >
        </result-card>
      </b-step-item>

      <template #navigation="{ next }">
        <div style="text-align: center">
          <b-button
            v-if="activeStep != 2"
            type="is-primary"
            icon-pack="fas"
            icon-right="forward"
            class="fa-1x"
            @click.prevent="
              () => {
                if (next.disabled) $router.push('../dashboard');
                else return next.action();
              }
            "
            style="margin: auto; text-align: center"
          >
            {{
              activeStep == 0
                ? "J'ai compris"
                : activeStep == 1
                ? "Commencer"
                : next.disabled
                ? "Terminer"
                : "Suivant"
            }}
          </b-button>
        </div>
      </template>
    </b-steps>
  </div>
</template>

<script>
import { addSurveyAnswers, addSurveyResult } from "../services/dbService";
import {
  computeSurveyResult,
  computeSurveyRadarResult,
} from "../services/resultService";
import surveyRowInput from "../components/Base/surveyRowInput.vue";
import apiService from "@/services/AxiosService.js";
import ResultCard from "@/components/ResultCard.vue";

import {
  genRadarAndDataToPdf,
  addRadarAndDataToPdf,
} from "@/services/pdfLibService";

export default {
  components: { surveyRowInput, ResultCard },
  data() {
    return {
      activeStep: 0,
      activeStepSurvey: 0,
      surveyResult: "",
      userShouldHaveResult: false,
      resultRadar: "",
      radarSvg: "",
      isNextLoading: false,
    };
  },
  props: {
    survey: {
      type: Object,
      required: true,
    },
  },
  mounted() {},
  computed: {
    surveyQuestions: function () {
      const jsonSurveyQuestions = JSON.parse(this.survey.surveyQuestions);

      if (jsonSurveyQuestions.surveyQuestions != undefined)
        return jsonSurveyQuestions.surveyQuestions;
      else return [];
    },
  },

  methods: {
    ValidateAnswers() {
      this.isNextLoading = true;
      if (this.surveyQuestions.length <= this.activeStepSurvey) {
        addSurveyAnswers(
          this.survey.type,
          this.$store.state.user,
          this.$store.state.survey.surveyAnswers
        )
          .then(() => {
            var results = computeSurveyResult(
              this.$store.state.survey.surveyAnswers,
              this.survey.type
            );
            var resultRadar = computeSurveyRadarResult(
              this.$store.state.survey.surveyAnswers,
              this.survey.type
            );
            this.surveyResult = results.resultRef;
            results.resultRadar = resultRadar.resultRadar;
            addSurveyResult(
              this.survey.type,
              this.$store.state.user,
              results
            ).then((dataCampaign /*{suMail, userShouldHaveResult}*/) => {
              this.userShouldHaveResult = dataCampaign.userShouldHaveResult;
              genRadarAndDataToPdf(results.resultRadar).then((radarSvg) => {
                this.radarSvg = radarSvg;
                results.dateAnswering = new Date();
                setTimeout(() => {
                  addRadarAndDataToPdf(
                    results.resultRadar,
                    this.radarSvg,
                    results,
                    this.$store.state.user.nameSurname,
                    this.$store.state.user.position
                  ).then(async (pdfBytes) => {
                    var txtBlob = await this.processFile(pdfBytes);
                    if (this.userShouldHaveResult == true) {
                      apiService.SendMailResult({
                        txtEmail: this.$store.state.user.data.email,
                        bIsSu: false,
                        txtName: this.$store.state.user.data.displayName,
                        txtType: this.survey.type,
                        txtFileResult:
                          "Définition de fonction synthétique " +
                          this.surveyResult +
                          ".pdf",
                        txtKey: "turlututu",
                        txtBlob: txtBlob,
                      });
                    } // le répondant ne peut pas voir son résultat
                    //else {
                    apiService.SendMailResult({
                      txtEmail: dataCampaign.suMail,
                      bIsSu: true,
                      txtName:
                        "Répondant :" +
                        this.$store.state.user.data.displayName +
                        "(" +
                        this.$store.state.user.data.email +
                        ")" +
                        (this.userShouldHaveResult == false
                          ? " - Le répondant n'a pas le droit de visualiser son résultat"
                          : " - Le répondant a reçu son résultat par email"),
                      txtType: this.survey.type,
                      txtFileResult:
                        "Définition de fonction synthétique " +
                        this.surveyResult +
                        ".pdf",
                      txtKey: "turlututu",
                      txtBlob: txtBlob,
                    });

                    // }
                  }); // end get radar
                }, 300); // end time out // ugly for safari bug generation radar
              }); // end gen radar
              this.$store.dispatch("updateUserDashboard"); // mise à jour des varaible hasResult/hasSurvey pour le dashboard

              this.$buefy.snackbar.open({
                message: "Le questionnaire a été sauvegardé.",
                queue: false,
              });
              this.resultRadar = resultRadar.resultRadar;

              this.isNextLoading = false;
              this.activeStep++;
            });
          })
          .catch((error) => {
            console.log(error);
            this.isNextLoading = false;

            this.$buefy.snackbar.open({
              message: "Une erreur de saisie a été détectée.",
              type: "is-danger",
              queue: false,
            });
          });
      } else {
        this.isNextLoading = false;

        scrollTo(0, 0);
      }
    },
    GetResultat() {
      return {
        type: this.survey.type,
        resultRef: this.surveyResult,
        userShouldHaveResult: this.userShouldHaveResult,
        dateAnswering: Date(),
        resultRadar: this.resultRadar,
      };
    },

    processFile(pdfBytes) {
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onload = (fileEvent) => {
          var fileContents = fileEvent.target.result;
          fileContents = fileContents.substr(fileContents.indexOf(",") + 1);
          resolve(fileContents);
        };
        reader.onerror = () => {
          reject("oops, something went wrong with the file reader.");
        };
        reader.readAsDataURL(pdfBytes);
      });
    },
  },
};
</script>

<style scoped>
.step-item {
  width: 80vw;
  margin: auto;
  margin-top: 2em;
}
</style>
